import React, { useEffect, useState } from 'react';
import Header from '../../../../components/Header';
import FooterTwo from '../../../../components/Footer';
import PageBanner from '../../../../components/PageBanner';
import { mediaUrl } from '../../../../services/assetUrl';
import { FaFilePdf, FaArrowRight, FaChartLine } from 'react-icons/fa';
import { getNirf } from '../../../../services/data.service';
import './Nirf.scss';

const Nirf = () => {
  // Backend-driven (DB-only). No bundled fallback — the page renders
  // loading → content → unavailable states from the /nirf singleton.
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getNirf();
        const payload = res?.data?.data || res?.data || null;
        if (active) setData(payload);
      } catch (e) {
        // backend unavailable / not seeded
        if (active) setData(null);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const hero = data?.hero || {};
  const button = data?.button || {};
  const categories = data?.categories || [];

  // Hero copy to fill the (taller) banner's left column: admin description or a
  // default, plus a couple of info pills derived from the ranking data.
  const nirfDescription = hero.subtitle || "Nagarjuna College of Engineering & Technology's National Institutional Ranking Framework (NIRF) submissions and performance across key parameters.";
  const nirfDocCount = categories.reduce((n, c) => n + (c.items?.length || 0), 0);
  const nirfFacts = [
    categories.length ? `${categories.length} Ranking ${categories.length === 1 ? "Category" : "Categories"}` : null,
    nirfDocCount ? `${nirfDocCount} Report${nirfDocCount === 1 ? "" : "s"}` : null,
  ].filter(Boolean);

  if (loading || !data) {
    return (
      <div className="nirf-page-premium">
        <Header />
        <PageBanner title="NIRF Rankings" eyebrow="Quality Assurance" />
        <main className="nirf-main-premium">
          <div className="nirf-container-premium" style={{ padding: '5rem 0', textAlign: 'center' }}>
            {loading ? 'Loading NIRF rankings…' : 'NIRF content is currently unavailable.'}
          </div>
        </main>
        <FooterTwo />
      </div>
    );
  }

  return (
    <div className="nirf-page-premium">
      <Header />

      <PageBanner
        className="page-banner--tall"
        title={hero.title || 'NIRF Rankings'}
        eyebrow={hero.eyebrow || 'Quality Assurance'}
        subtitle={nirfDescription}
        facts={nirfFacts}
        image={hero.bannerImage ? mediaUrl(hero.bannerImage) : undefined}
      />

      <main className="nirf-main-premium">
        {/* Dynamic Background Elements */}
        <div className="nirf-bg-glow-1"></div>
        <div className="nirf-bg-glow-2"></div>

        <div className="nirf-container-premium">

          <div className="nirf-header-actions-premium">
            <div className="nirf-title-wrapper">
              {data.badge && <span className="nirf-badge">{data.badge}</span>}
              <h2 className="nirf-overview-title-premium">
                {data.overviewTitle}
              </h2>
            </div>
            {button.label && (
              <a href={button.link || '/iqac'} className="nirf-btn-premium">
                <span>{button.label}</span>
                <div className="nirf-btn-icon-wrapper">
                  <FaArrowRight />
                </div>
              </a>
            )}
          </div>

          <div className="nirf-image-wrapper-premium">
            <div className="nirf-image-glass">
              <img
                src={mediaUrl(data.image || "/images/nirf-page/nirf-rank.png")}
                alt="NIRF Ranking Certificate"
              />
            </div>
          </div>

          <div className="nirf-bento-grid">
            {categories.map((category, index) => (
              <div key={category.id || index} className={`nirf-bento-card delay-${index}`}>
                <div className="nirf-bento-header">
                  <div className="nirf-bento-icon">
                    <FaChartLine />
                  </div>
                  <h3 className="nirf-bento-title">{category.title}</h3>
                </div>

                {/* PDF SECTION: TIMELINE STYLE */}
                <div className="nirf-timeline-content">
                  {(category.items || []).map((item, itemIndex) => (
                    <div key={`${category.id || index}-${itemIndex}`} className="nirf-timeline-row">
                      <div className="nirf-timeline-visual">
                        <div className="nirf-timeline-dot"></div>
                        {itemIndex !== category.items.length - 1 && <div className="nirf-timeline-line"></div>}
                      </div>

                      <div className="nirf-timeline-doc-wrapper">
                        <a
                          href={mediaUrl(item.localHref || item.href)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nirf-timeline-doc-link"
                        >
                          <div className="nirf-timeline-doc-left">
                            <div className="nirf-timeline-doc-icon">
                              <FaFilePdf />
                            </div>
                            <span className="nirf-timeline-doc-text">{item.text}</span>
                          </div>
                          <div className="nirf-timeline-doc-right">
                            <FaArrowRight className="nirf-timeline-doc-arrow" />
                          </div>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </main>

      <FooterTwo />
    </div>
  );
};

export default Nirf;
